module.exports = __webpack_public_path__ + "static/media/bag_light.2f11ef7e.svg";